import * as React from 'react';
import DataChecker from './DataChecker';
import { Accordion, AccordionDetails, AccordionSummary, Box, Stack, Typography } from '@mui/material';
import LocalHospitalIcon from '@mui/icons-material/LocalHospital';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Common from '../utilities/common';
import WcIcon from '@mui/icons-material/Wc';
import BadgeOutlinedIcon from '@mui/icons-material/BadgeOutlined';
import CakeOutlinedIcon from '@mui/icons-material/CakeOutlined';
import LocalPhoneOutlinedIcon from '@mui/icons-material/LocalPhoneOutlined';
import SignpostOutlinedIcon from '@mui/icons-material/SignpostOutlined';
import TrafficOutlinedIcon from '@mui/icons-material/TrafficOutlined';
import MarkunreadMailboxOutlinedIcon from '@mui/icons-material/MarkunreadMailboxOutlined';
import BusinessOutlinedIcon from '@mui/icons-material/BusinessOutlined';
import HolidayVillageOutlinedIcon from '@mui/icons-material/HolidayVillageOutlined';
import LocationCityOutlinedIcon from '@mui/icons-material/LocationCityOutlined';
import ConfirmationNumberOutlinedIcon from '@mui/icons-material/ConfirmationNumberOutlined';
import AlternateEmailOutlinedIcon from '@mui/icons-material/AlternateEmailOutlined';
import LightOutlinedIcon from '@mui/icons-material/LightOutlined';
import LocalFireDepartmentOutlinedIcon from '@mui/icons-material/LocalFireDepartmentOutlined';
import FavoriteIcon from '@mui/icons-material/Favorite';

export interface IHealthAnalyzerState {
    iconColor: string;
}

export default class HealthAnalyzer extends React.Component<{}, IHealthAnalyzerState> {
    public constructor(props: {}) {
        super(props);

        this.state = {
            iconColor: Common.SUCCESS_COLOR_DARK
        }
    }

    public render(): React.ReactElement<{}> {
        return (
            <Accordion style={{marginBottom: '20px'}}>
                <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                    <FavoriteIcon style={{fontSize: '30px', color: this.state.iconColor}}/>
                    <Typography variant='h6'>Calidad de los datos</Typography>
                </AccordionSummary>
                <AccordionDetails>
                    <DataChecker icon={<BadgeOutlinedIcon/>} field='nombre' errorMessage='{0} registros no tienen el nombre asignado' onHasErrors={this.SetColor.bind(this)}/>
                    <DataChecker icon={<BadgeOutlinedIcon/>} field='Apellidos' errorMessage='{0} registros no tienen los apellidos asignado' onHasErrors={this.SetColor.bind(this)}/>
                    <DataChecker icon={<WcIcon/>} field='sexo' errorMessage='{0} registros no tienen sexo asignado' onHasErrors={this.SetColor.bind(this)}/>
                    <DataChecker icon={<CakeOutlinedIcon/>} field='FechaNacimiento' errorMessage='{0} registros no tienen la fecha de nacimiento asignada' onHasErrors={this.SetColor.bind(this)}/>
                    <DataChecker icon={<LocalPhoneOutlinedIcon/>} field='telefono' errorMessage='{0} registros no tienen telefono asignado' onHasErrors={this.SetColor.bind(this)}/>
                    <DataChecker icon={<TrafficOutlinedIcon/>} field='tipoVia' errorMessage='{0} registros no tienen el tipo de via asignado' onHasErrors={this.SetColor.bind(this)}/>
                    <DataChecker icon={<SignpostOutlinedIcon/>} field='NombreVia' errorMessage='{0} registros no tienen el nombre de la via asignado' onHasErrors={this.SetColor.bind(this)}/>
                    <DataChecker icon={<ConfirmationNumberOutlinedIcon/>} field='numeroVia' errorMessage='{0} registros no tienen el número de la via asignado' onHasErrors={this.SetColor.bind(this)}/>
                    <DataChecker icon={<BusinessOutlinedIcon/>} field='RestoDireccion' errorMessage='{0} registros no tienen el resto de la dirección asignado' onHasErrors={this.SetColor.bind(this)}/>
                    <DataChecker icon={<HolidayVillageOutlinedIcon/>} field='Municipio' errorMessage='{0} registros no tienen el municipio asignado' onHasErrors={this.SetColor.bind(this)}/>
                    <DataChecker icon={<LocationCityOutlinedIcon/>} field='Provincia' errorMessage='{0} registros no tienen la provincia asignada' onHasErrors={this.SetColor.bind(this)}/>
                    <DataChecker icon={<MarkunreadMailboxOutlinedIcon/>} field='cp' errorMessage='{0} registros no tienen el código postal asignado' onHasErrors={this.SetColor.bind(this)}/>
                    <DataChecker icon={<AlternateEmailOutlinedIcon/>} field='Email' errorMessage='{0} registros no tienen el email asignado' onHasErrors={this.SetColor.bind(this)}/>
                    <DataChecker icon={<LightOutlinedIcon/>} field='CupsLuz' errorMessage='{0} registros no tienen el CUP de la luz asignado' onHasErrors={this.SetColor.bind(this)}/>
                    <DataChecker icon={<LocalFireDepartmentOutlinedIcon/>} field='CupsGas' errorMessage='{0} registros no tienen el CUP del gas asignado' onHasErrors={this.SetColor.bind(this)}/>
                </AccordionDetails>
            </Accordion>
        )
    }

    private SetColor() {
        this.setState(
            {
                iconColor: Common.ERROR_COLOR_DARK
            }
        );
    }
}